var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "text-right lg:text-left" }, [
      _c("span", { class: ["status-marker", _vm.color] }, [
        _vm.statusMessage
          ? _c("span", [_vm._v(_vm._s(_vm.statusMessage))])
          : _c("span", { staticClass: "text-[#BABBC2]" }, [
              _vm._v(
                _vm._s(
                  _vm.locales &&
                    _vm.locales.property &&
                    _vm.locales.property.inactive
                )
              )
            ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97d0bc96", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97d0bc96","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ManagePropertiesStatus.vue
// module id = 756
// module chunks = 1